import { render } from "./presenters.vue?vue&type=template&id=a7f3d1ac&scoped=true"
import script from "./presenters.vue?vue&type=script&lang=js"
export * from "./presenters.vue?vue&type=script&lang=js"

import "./presenters.vue?vue&type=style&index=0&id=a7f3d1ac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a7f3d1ac"

export default script